import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=d88abe36&scoped=true&lang=pug&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88abe36",
  null
  
)

export default component.exports